import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, getWorkspace, setWorkspace as setWs, setSessionToken, clearSessionToken } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [workspace, setWorkspaceState] = useState(getWorkspace());

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me if OAuth returned session_id fragment — AuthCallback handles it
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const switchWorkspace = (ws) => {
    setWs(ws);
    setWorkspaceState(ws);
    window.location.reload(); // simplest way to refresh all queries
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (e) {}
    clearSessionToken();
    setUser(null);
    window.location.href = '/';
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, workspace, switchWorkspace, logout, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
